import { useEffect } from "react";
import { Typography, Spin } from "antd";
import { useAuth } from "@/hooks/useAuth";

const { Title, Text } = Typography;

export default function SignOutPage() {
  const { signOut } = useAuth();

  useEffect(() => {
    signOut();
  }, [signOut]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "#F8F7F5",
        padding: 24,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          marginBottom: 32,
        }}
      >
        <img
          src="/secondary-logo-gradient.png"
          alt="AIXA"
          style={{ width: 40, height: 40, objectFit: "contain" }}
        />
        <Title level={2} style={{ margin: 0, color: "#0F6E56", letterSpacing: "0.5px" }}>
          AIXA <span style={{ fontWeight: 400 }}>Share</span>
        </Title>
      </div>

      <Spin size="large" />
      <Text type="secondary" style={{ marginTop: 16 }}>
        Signing out...
      </Text>
    </div>
  );
}
